import { createFileRoute } from '@tanstack/react-router';
import { requireWorkstation } from '../../../../utils/workstationGuard';
import { lazy, Suspense } from 'react';
import Loading from '../../../../pages/Loading/Loading';

const PrintTags = lazy(() => import('../../../../pages/PrintTags/PrintTags'));

export const Route = createFileRoute('/$lang/_authenticated/print-tags')({
  beforeLoad: requireWorkstation,
  component: () => (
    <Suspense fallback={<Loading />}>
      <PrintTags />
    </Suspense>
  ),
});
